import { useContext } from "react";
import { NewAuthContext } from "../context/NewAuthContext.js";

const useAuthContext = () => useContext(NewAuthContext);
export default useAuthContext;
